// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuCard_wrapper__VNh02","icon":"MenuCard_icon__tgZL4","title":"MenuCard_title__yjWhb","description":"MenuCard_description__-uZXK"};